import { ballArr, count, singleDouble, smallBig, dragonTiger } from '../../../../helpers/resPatterns';
import dayjs from 'dayjs';

var isStraight = function(str, i) {
  var arr = str.split(',').slice(i, i + 3);
  var re = [];
  arr.sort((a, b) => {
    return a - b;
  });
  arr.sort((a, b) => {
    re.push(a - b);
  });
  var num = re.reduce((a, b) => {
    return a + b;
  }, 0);
  if (num == 2) {
    return '顺子 ';
  } else if (re.includes(1)) {
    return '半顺';
  } else {
    return '杂六';
  }
};
let treeChildren = index => {
  return [
    {
      align: 'center',
      title: '单',
      render: (h, { row }) => <span>{row[index] ? row[index].single : 0}</span>
    },
    {
      align: 'center',
      title: '双',
      render: (h, { row }) => <span>{row[index] ? row[index].double : 0}</span>
    },
    {
      align: 'center',
      title: '大',
      render: (h, { row }) => <span>{row[index] ? row[index].big : 0}</span>
    },
    {
      align: 'center',
      title: '小',
      render: (h, { row }) => <span>{row[index] ? row[index].small : 0}</span>
    }
  ];
};

const choose5 = () => {
  let list = Vue => {
    let hasBallOpacity = (x, xIndex, data, dataIndex) => {
      let resClass = '';
      if (Vue.selectType === 0) {
        resClass += !~Vue.selectNumArr.indexOf(x) ? ' opacity' : '';
      }
      if (Vue.selectType === 1) {
        resClass += (Vue.selectValue != singleDouble(x)) == 0 ? ' ' : ' opacity';
      }
      if (Vue.selectType === 2) {
        resClass += Vue.selectValue == x > 5 ? ' opacity' : '';
      }
      if (Vue.selectType === 3) {
        let lastStr = data[dataIndex - 1] ? data[dataIndex - 1].resultStr : '';
        let nextStr = data[dataIndex + 1] ? data[dataIndex + 1].resultStr : '';
        let lastArr = ballArr(lastStr);
        let nextArr = ballArr(nextStr);

        if (lastArr[xIndex] === x || nextArr[xIndex] === x) {
        } else {
          resClass += ' opacity';
        }
      }
      return resClass;
    };
    return Vue.showMobile && Vue.curKey == 'kjhm'
      ? [
          {
            title: '时间',
            align: 'center',
            render: (h, { row }) => {
              return <span>{dayjs(row.resultDate).format('HH:mm')}</span>;
            }
          },
          {
            title: '期数',
            align: 'center',
            key: 'issueId',
            render: (h, { row }) => {
              return <span>{row.issueId.substring(row.issueId.length - 4)}</span>;
            }
          },
          {
            renderHeader: (h, params) => {
              return (
                <div class="showBallHandle">
                  <span on-click={_ => (Vue.tableShowBallType = 0)} class={Vue.tableShowBallType == 0 && 'active'}>
                    {Vue.showMobile ? '号码' : '显示号码'}
                  </span>
                  <span on-click={_ => (Vue.tableShowBallType = 1)} class={Vue.tableShowBallType == 1 && 'active'}>
                    {Vue.showMobile ? '大小' : '显示大小'}
                  </span>
                  <span on-click={_ => (Vue.tableShowBallType = 2)} class={Vue.tableShowBallType == 2 && 'active'}>
                    {Vue.showMobile ? '单双' : '显示单双'}
                  </span>
                </div>
              );
            },
            width: 352,
            align: 'center',
            render: (h, { row, index }) => {
              let arr = ballArr(row.resultStr);
              let boxClassName = 'ball';
              if (Vue.tableShowBallType == 0) {
                boxClassName += ' num';
                arr = arr.map((x, i) => {
                  let className = '';
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: x, className };
                });
              }
              if (Vue.tableShowBallType == 1) {
                boxClassName += ' smallBig';
                arr = arr.map((x, i) => {
                  let className;
                  if (x == '11') {
                    className = 'he';
                  } else {
                    className = smallBig(x, 11) == 0 ? 'small' : 'big';
                  }
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: '', className };
                });
              }
              if (Vue.tableShowBallType == 2) {
                boxClassName += ' singleDouble';
                arr = arr.map((x, i) => {
                  let className;
                  if (x == '11') {
                    className = 'he';
                  } else {
                    className = singleDouble(x) != 0 ? 'double' : 'single';
                  }
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: '', className };
                });
              }

              return (
                <div class={boxClassName}>
                  {arr.map((x, i) => {
                    return (
                      <span class={x.className} key={i} style={{ border: `${Vue.tableShowBallType == 0 ? '1px solid  #1299df' : 'none'}` }}>
                        {x.value && x.value < 10 ? '0' + x.value : x.value}
                      </span>
                    );
                  })}
                </div>
              );
            }
          }
        ]
      : [
          {
            title: '时间',
            align: 'center',
            width: '160',
            render: (h, { row }) => {
              return <span>{dayjs(row.resultDate).format('YYYY-MM-DD HH:mm:ss')}</span>;
            }
          },
          {
            title: '期数',
            align: 'center',
            key: 'issueId'
          },
          {
            renderHeader: (h, params) => {
              return (
                <div class="showBallHandle">
                  <span on-click={_ => (Vue.tableShowBallType = 0)} class={Vue.tableShowBallType == 0 && 'active'}>
                    显示号码
                  </span>
                  <span on-click={_ => (Vue.tableShowBallType = 1)} class={Vue.tableShowBallType == 1 && 'active'}>
                    显示大小
                  </span>
                  <span on-click={_ => (Vue.tableShowBallType = 2)} class={Vue.tableShowBallType == 2 && 'active'}>
                    显示单双
                  </span>
                </div>
              );
            },
            width: 352,
            align: 'center',
            render: (h, { row, index }) => {
              let arr = ballArr(row.resultStr);
              let boxClassName = 'ball';
              if (Vue.tableShowBallType == 0) {
                boxClassName += ' num';
                arr = arr.map((x, i) => {
                  let className = '';
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: x, className };
                });
              }
              if (Vue.tableShowBallType == 1) {
                boxClassName += ' smallBig';
                arr = arr.map((x, i) => {
                  let className;
                  if (x == '11') {
                    className = 'he';
                  } else {
                    className = smallBig(x, 11) == 0 ? 'small' : 'big';
                  }
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: '', className };
                });
              }
              if (Vue.tableShowBallType == 2) {
                boxClassName += ' singleDouble';
                arr = arr.map((x, i) => {
                  let className;
                  if (x == '11') {
                    className = 'he';
                  } else {
                    className = singleDouble(x) != 0 ? 'double' : 'single';
                  }
                  className += hasBallOpacity(x, i, Vue.dataSource, index);
                  return { value: '', className };
                });
              }

              return (
                <div class={boxClassName}>
                  {arr.map((x, i) => {
                    return (
                      <span class={x.className} key={i} style={{ border: `${Vue.tableShowBallType == 0 ? '1px solid  #1299df' : 'none'}` }}>
                        {x.value && x.value < 10 ? '0' + x.value : x.value}
                      </span>
                    );
                  })}
                </div>
              );
            }
          },
          {
            title: '总和',
            align: 'center',
            width: 180,
            render: (h, { row }) => {
              let arr = ballArr(row.resultStr);
              return (
                <div class="insideTableTd">
                  <p class="count brr">{count(arr)}</p>
                  <p class="singleDouble brr">{singleDouble(count(arr)) == 0 ? <span class="blue">单</span> : <span class="red">双</span>}</p>
                  <p class="smallBig">
                    {count(arr) == 30 ? (
                      <span class="blue">和</span>
                    ) : smallBig(count(arr), 60) == 0 ? (
                      <span class="blue">小</span>
                    ) : (
                      <span class="red">大</span>
                    )}
                  </p>
                </div>
              );
            }
          },
          {
            title: '龙虎',
            align: 'center',
            render: (h, { row }) => {
              let arr = ballArr(row.resultStr);
              let res = dragonTiger(arr[0], arr[4]);
              if (res == 0) {
                return <span class="red">龙</span>;
              } else if (res == 1) {
                return <span class="blue">虎</span>;
              } else {
                return <span class="green">和</span>;
              }
            }
          },
          {
            title: '前三',
            align: 'center',
            render: (h, { row }) => {
              var n = isStraight(row.resultStr, 0);
              return <span class="red">{n}</span>;
            }
          },
          {
            title: '中三',
            align: 'center',
            render: (h, { row }) => {
              var n = isStraight(row.resultStr, 1);
              return <span class="red">{n}</span>;
            }
          },
          {
            title: '后三',
            align: 'center',
            render: (h, { row }) => {
              var n = isStraight(row.resultStr, 2);
              return <span class="red">{n}</span>;
            }
          }
        ];
  };

  let doubleStatisColumns1 = (() => {
    var arr = [
      {
        title: '号码',
        width: 176,
        align: 'center',
        key: 'title'
      }
    ];
    for (let i = 1; i < 12; i++) {
      var o = {};
      o.title = i;
      o.align = 'center';
      o.render = (h, { row }) => {
        // console.log('row', row)
        return <span>{row[i] || 0}</span>;
      };
      arr.push(o);
    }
    return arr;
  })();

  let doubleStatisColumns2 = [
    {
      title: '球次',
      key: 'title',
      align: 'center',
      width: 176
    },
    {
      title: '总和',
      align: 'center',
      children: treeChildren('count')
    },
    {
      title: '第一球',
      align: 'center',
      children: treeChildren(0)
    },
    {
      title: '第二球',
      align: 'center',
      children: treeChildren(1)
    },
    {
      title: '第三球',
      align: 'center',
      children: treeChildren(2)
    },
    {
      title: '第四球',
      align: 'center',
      children: treeChildren(3)
    },
    {
      title: '第五球',
      align: 'center',
      children: treeChildren(4)
    }
  ];

  return { list, doubleStatisColumns1, doubleStatisColumns2 };
};

export default choose5;



// WEBPACK FOOTER //
// ./src/pages/Trend/Jishikaijiang/columns/choose5.js